module.exports = __webpack_public_path__ + "static/media/antonio-marcos-de-lima-melo.fd377ff4.jpg";